import { combineReducers } from "redux";
import medicamentos from "./medicamento/reducer";
import puntos from "./punto/reducer";
import sindromes from "./sindrome/reducer";
import sindromeAnalisis from "./sindromeAnalisis/reducer";
import homeosiniatria from "./homeosiniatria/reducer";
import antihomotoxicos from "./antihomotoxicos/reducer";
import sintomas from "./sintoma/reducer";
import sintomasAcupuntura from "./sintomaAcupuntura/reducer";

export default combineReducers({
  holonmed: combineReducers({
    sintomasHomeopatia: sintomas,
    sintomasAcupuntura,
    puntos,
    homeosiniatria,
    antihomotoxicos,
    sindromeAnalisis,
  }),
  medicamentos,
  sindromes,
});
